<template>
  <div class="login-outer">
    <div class="login-inner">
      <h4>{{ $t("login.TITLE") }}</h4>
      <form @submit.prevent="handleSubmit">
        <label for="name">{{ $t("login.FIELD_NAME") }}</label>
        <div>
          <input
            id="name"
            type="text"
            class="input-text"
            v-model="name"
            required
            autofocus
            autoCorrect="off"
            autoCapitalize="none"
          />
        </div>
        <div>
          <label for="password">{{ $t("login.FIELD_PWD") }}</label>
          <div>
            <input
              id="password"
              type="password"
              class="input-text"
              v-model="password"
              required
              autoCorrect="off"
              autoCapitalize="none"
            />
          </div>
        </div>
        <div>
          <button type="submit" class="login-button">
            {{ $t("login.BUTTON_LOGIN") }}
          </button>
          <div class="reset-reminder">
            <em>{{ $t("login.RESET_REMINDER") }}</em>
            <div>
              <button
                type="button"
                class="reset-button"
                v-on:click="resetPassword"
              >
                {{ $t("login.BUTTON_RESET") }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="errorMsg">
          {{ errorMsg }}
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import apiClient from "../services/apiClient";

export default {
  data() {
    return {
      name: "",
      password: "",
      errorMsg: undefined,
      messages: {
        ERR_WRONG_USER_OR_LOGIN: this.$t("login.ERR_WRONG_USER_OR_LOGIN"),
        ERR_REMOTE_UNREACHABLE: this.$t("login.ERR_REMOTE_UNREACHABLE"),
        ERR_LOCAL_UNREACHABLE: this.$t("login.ERR_LOCAL_UNREACHABLE"),
        ERR_REMOTE_ERROR: this.$t("login.ERR_REMOTE_ERROR"),
        ERR_PASSWORD_EMPTY: this.$t("login.ERR_PASSWORD_EMPTY")
      }
    };
  },
  methods: {
    ...mapActions(["setUser", "setToken", "setProfile", "hasToken"]),
    ...mapGetters(["user"]),

    handleSubmit(e) {
      e.preventDefault();
      this.errorMsg = undefined;
      if (this.password.length > 0) {
        const client = new apiClient({ $http: this.$http });
        this._doLogin(
          this.name,
          this.password,
          client,
          client.login,
          client.profile,
          () => this.$emit("online"),
          err => {
            const srcErr = err;
            if (err === this.messages.ERR_REMOTE_UNREACHABLE) {
              return this._doLogin(
                this.name,
                this.password,
                client,
                client.localLogin,
                client.localProfile,
                () => this.$emit("offline"),
                localErr => {
                  this.errorMsg = srcErr;
                  console.log(localErr);
                }
              );
            }
          }
        );
      } else {
        this.errorMsg = this.messages.ERR_PASSWORD_EMPTY;
      }
    },

    resetPassword() {
      this.$router.push("/reset");
    },

    async _doLogin(
      user,
      pwd,
      client,
      fnLogin,
      fnProfile,
      fnOnlineCallback,
      fnErrorCallback
    ) {
      await fnLogin
        .call(client, this.name, this.password)
        .then(response => {
          console.log(response);
          this.setUser(response.user);
          this.setToken(response.token);
          return this.hasToken().then(hasToken => {
            if (hasToken) {
              return fnProfile.call(client);
            } else {
              throw new Error("invalid token");
            }
          });
        })
        .then(profile => {
          console.log(profile);
          return this.setProfile(profile);
        })
        .then(() => {
          //this.$emit("online");
          if (fnOnlineCallback) {
            fnOnlineCallback();
          }
          this.$emit("loggedIn", this.$store.user);
          if (this.$route.params.nextUrl != null) {
            this.$router.push(this.$route.params.nextUrl);
          } else {
            this.$router.push("/");
          }
        })
        .catch(error => {
          const response = error.response || error;
          const data = response.data || response;
          const remoteError = data.error;
          console.log("login failed", response);
          if (response.status === 401) {
            this.errorMsg = this.messages.ERR_WRONG_USER_OR_LOGIN;
          } else if (
            response.status === 500 &&
            remoteError &&
            (remoteError.errno === "ECONNREFUSED" ||
              remoteError.errno === "ENOTFOUND")
          ) {
            this.errorMsg = this.messages.ERR_REMOTE_UNREACHABLE;
            console.log(this.errorMsg);
            //this.$emit("offline");
          } else {
            if (data.message) {
              if (data.message === "Network Error") {
                this.errorMsg = this.messages.ERR_LOCAL_UNREACHABLE;
              } else {
                this.errorMsg = `${this.messages.ERR_REMOTE_ERROR} ${data.message}`;
              }
            } else {
              this.errorMsg = JSON.stringify(error);
            }
          }
          if (fnErrorCallback) {
            return fnErrorCallback(this.errorMsg);
          }
        });
    }
  },
  mounted: function () {
    const setUserOnline = online => {
      const curUser = this.user();
      curUser.online = online;
      console.log("set user ", curUser);
      this.setUser(curUser);
    };

    this.$on("online", () => {
      setUserOnline(true);
    });
    this.$on("offline", () => {
      setUserOnline(false);
    });
  }
};
</script>

<style scoped>
div.login-outer {
  width: 100%;
}
div.login-inner {
  width: 200px;
  margin: 0 auto;
}
div.login-inner h4 {
  text-align: center;
}
div.reset-reminder {
  text-align: center;
  font-size: 0.8rem;
  width: 100%;
}
.input-text {
  width: 100%;
  margin-top: 4px;
  margin-bottom: 8px;
}
.login-button {
  width: 80%;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10%;
  margin-right: 10%;
}
.reset-button {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
